/* ==========================================================================
   crocs-plp @ 1.2.0 — barra de filtros del listado

   Replica el funcionamiento de viste-theme
   (assets/collection-quick-filters.js): los valores se marcan dentro del popout
   sin recargar, se aplican con "Aplicar", y el resultado se pide por AJAX.

   Diferencias respecto de viste: aca la pastilla "Filtros" abre todos los
   grupos a la vez, y el orden se aplica por el mismo camino en vez de un
   <select> aparte.
   ========================================================================== */

   (function () {
    'use strict';
  
    var GRID = '[data-products-grid]';
    var TOOLBAR = '[data-crocs-quick-filters]';
    var COUNT = '[data-results-count]';
  
    function swapHtml(doc, selector) {
      var from = doc.querySelector(selector);
      var to = document.querySelector(selector);
      if (!from || !to) return;
      to.innerHTML = from.innerHTML;
    }
  
    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
  
      /* La barra se repinta junto con la grilla. submitForm de Broadcast solo
         cambia [data-products-grid], asi que las pastillas quedaban con el estado
         viejo: despues de "Limpiar" los chips seguian marcados y los contadores
         intactos, y parecia que el boton no hacia nada. */
      swapHtml(doc, GRID);
      swapHtml(doc, TOOLBAR);
      swapHtml(doc, COUNT);
    }
  
    function applyUrl(url) {
      var grid = document.querySelector(GRID);
      if (!grid || !window.DOMParser) {
        window.location.href = url;
        return;
      }
  
      window.history.pushState(null, '', url);
      grid.classList.add('is-loading');
  
      fetch(url, { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          render(html);
          var current = document.querySelector(GRID);
          if (current) current.classList.remove('is-loading');
        })
        .catch(function () {
          /* Si el fetch falla se cae a una navegacion normal en vez de dejar la
             pagina con la URL cambiada y la grilla vieja. */
          window.location.href = url;
        });
    }
  
    function paramsFor(scope) {
      /* Un popout puede traer varios grupos (la pastilla "Filtros"): se junta el
         param_name de cada grupo con los valores marcados dentro de el. */
      var groups = scope.querySelectorAll('[data-crocs-group]');
      var out = [];
      var n;
  
      if (!groups.length) return out;
  
      for (n = 0; n < groups.length; n++) {
        var param = groups[n].getAttribute('data-crocs-filter-param');
        if (!param) continue;
        var chips = groups[n].querySelectorAll('.crocs-plp-chip.is-active');
        var values = [];
        var k;
        for (k = 0; k < chips.length; k++) {
          values.push(chips[k].getAttribute('data-crocs-value'));
        }
        out.push({ param: param, values: values });
      }
  
      return out;
    }
  
    function buildUrl(entries) {
      var url = new URL(window.location.href);
      var n;
  
      for (n = 0; n < entries.length; n++) {
        var param = entries[n].param;
        var k;
  
        /* delete ya borra todas las apariciones del nombre, asi que no hay que
           recorrer las claves. Antes esto iba dentro de un for sobre
           Array.prototype.slice.call(url.searchParams.keys()), que es siempre un
           array vacio: keys() devuelve un iterador, no un array-like, y sin
           length slice lee cero elementos. El delete no llegaba a ejecutarse
           nunca, asi que "Limpiar" dejaba la URL intacta y "Aplicar" acumulaba
           valores repetidos en vez de reemplazarlos. */
        url.searchParams.delete(param);
  
        for (k = 0; k < entries[n].values.length; k++) {
          url.searchParams.append(param, entries[n].values[k]);
        }
      }
  
      /* Forzar siempre el filtro de disponibilidad al aplicar o limpiar filtros */
      url.searchParams.set('filter.v.availability', '1');
  
      /* Cualquier cambio de filtro devuelve a la primera pagina */
      url.searchParams.delete('page');
      return url.toString();
    }
  
    function closeAll(except) {
      /* Se busca en el documento y no en un root guardado: la barra se repinta
         entera en cada aplicacion. */
      var panels = document.querySelectorAll('[data-crocs-panel]');
      var toggles = document.querySelectorAll('[data-crocs-toggle]');
      var n;
      for (n = 0; n < panels.length; n++) {
        if (panels[n] !== except) panels[n].setAttribute('hidden', '');
      }
      for (n = 0; n < toggles.length; n++) {
        var panel = toggles[n].parentNode.querySelector('[data-crocs-panel]');
        toggles[n].setAttribute('aria-expanded', panel && !panel.hasAttribute('hidden') ? 'true' : 'false');
      }
    }
  
    function onClick(event) {
      if (!event.target.closest) return;
  
      var t = event.target;
  
      if (!t.closest(TOOLBAR)) {
        closeAll(null);
        return;
      }
  
      // NUEVO: Manejador para el botón de cerrar en mobile
      var closeMobileBtn = t.closest('[data-crocs-close-mobile]');
      if (closeMobileBtn) {
        closeAll(null);
        return;
      }
  
      var toggle = t.closest('[data-crocs-toggle]');
      if (toggle) {
        var panel = toggle.parentNode.querySelector('[data-crocs-panel]');
        var wasOpen = panel && !panel.hasAttribute('hidden');
        closeAll(null);
        if (panel && !wasOpen) {
          panel.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }
  
      var chip = t.closest('.crocs-plp-chip');
      if (chip) {
        var on = chip.classList.toggle('is-active');
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        return;
      }
  
      var apply = t.closest('[data-crocs-apply]');
      if (apply) {
        var scope = apply.closest('[data-crocs-panel]');
        closeAll(null);
        applyUrl(buildUrl(paramsFor(scope)));
        return;
      }
  
      var clear = t.closest('[data-crocs-clear]');
      if (clear) {
        var scope2 = clear.closest('[data-crocs-panel]');
        var entries = paramsFor(scope2);
        var n;
        for (n = 0; n < entries.length; n++) entries[n].values = [];
  
        /* Se desmarca en el acto, sin esperar el round trip. El caso corriente de
           "Limpiar" es deshacer chips recien marcados y todavia sin aplicar: ahi
           la URL que sale de buildUrl es identica a la actual, asi que el pedido
           no cambiaba nada visible y el boton parecia muerto. */
        var marked = scope2.querySelectorAll('.crocs-plp-chip.is-active');
        for (n = 0; n < marked.length; n++) {
          marked[n].classList.remove('is-active');
          marked[n].setAttribute('aria-pressed', 'false');
        }
  
        var next = buildUrl(entries);
  
        /* Si no habia nada aplicado en la URL no hay nada que pedir, y el panel se
           queda abierto para seguir eligiendo. */
        if (next === window.location.href) return;
  
        closeAll(null);
        applyUrl(next);
        return;
      }
  
      var reset = t.closest('[data-filter-update-url]');
      if (reset && reset.getAttribute('href')) {
        event.preventDefault();
        var resetUrl = new URL(reset.getAttribute('href'), window.location.origin);
        resetUrl.searchParams.set('filter.v.availability', '1');
        resetUrl.searchParams.delete('page');
        closeAll(null);
        applyUrl(resetUrl.toString());
        return;
      }
  
      var sort = t.closest('[data-crocs-sort-value]');
      if (sort) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.getAttribute('data-crocs-sort-value'));
  
        /* Asegurar que el ordenamiento no pierda la disponibilidad */
        url.searchParams.set('filter.v.availability', '1');
  
        url.searchParams.delete('page');
        closeAll(null);
        applyUrl(url.toString());
        return;
      }
    }
  
    function onKeydown(event) {
      if (event.key === 'Escape') closeAll(null);
    }
  
    function onPopState() {
      /* La barra y la grilla se repintan con la URL a la que vuelve el navegador.
         Sin esto, el boton atras cambiaba la URL y dejaba los resultados viejos:
         collection-filters-form solo escucha popstate si la coleccion usa la barra
         lateral o el orden nativos de Broadcast, y esta no usa ninguno. */
      var url = window.location.href;
      fetch(url, { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(render)
        .catch(function () {});
    }
  
    var bound = false;
  
    function bind() {
      if (bound) return;
      bound = true;
  
      /* Los listeners van en document y filtran por el contenedor: la barra se
         reemplaza entera en cada aplicacion, asi que uno puesto sobre el elemento
         se perderia. Y van una sola vez: atarlos por cada <quick-filters> los
         duplicaba en cada repintado. */
      document.addEventListener('click', onClick);
      document.addEventListener('keydown', onKeydown);
      window.addEventListener('popstate', onPopState);
    }
  
    function init() {
      /* Los listeners se atan antes que nada. Antes se ataban despues del salto de
         disponibilidad de aca abajo, que corta init con un return: en la primera
         visita a una coleccion la barra quedaba sin escuchar nada y los filtros no
         respondian hasta recargar la pagina. */
      bind();
  
      /* Al entrar a la coleccion, revisar si falta el filtro de disponibilidad.
         Si falta, lo agregamos y recargamos la vista automaticamente. */
      var currentUrl = new URL(window.location.href);
      if (!currentUrl.searchParams.has('filter.v.availability') && document.querySelector('collection-filters-form')) {
        currentUrl.searchParams.set('filter.v.availability', '1');
        applyUrl(currentUrl.toString());
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  
    document.addEventListener('shopify:section:load', init);
  })();
  